const onlyNumbersRegex = /^[0-9]*$/i;
const emailValidationRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/i;

export {
  onlyNumbersRegex,
  emailValidationRegex,
};
